import type { ReactNode } from "react";
import { env } from "@/lib/env";
import "@/features/auth/login.css";

/**
 * GİRİŞ AKIŞININ ÇERÇEVESİ (3 Kasım 2026, ikinci tasarım turu).
 *
 * Odak: form. Sayfada başka bir karar yok; tek dolu düğme formun kendi düğmesi.
 * Desen: iki panel. Solda kurumun fotoğrafı ve adı, sağda sakin yüzeyde form; telefonda fotoğraf üstte alçak bir şerit.
 * Ritim: başlık ile alanlar arası 24, alanlar arası 16, form ile alt not arası en az 32.
 *
 * NEDEN ORTAK. Giriş fotoğrafın üstünde kart, sıfırlama ve davet düz zeminde kart çiziyordu: e-postadaki bağlantıdan gelen kişi
 * başka bir ürüne gelmiş gibi oluyordu. Üç ekran aynı çerçevede, form değişince çerçeve yerinde kalıyor.
 *
 * AD, ÜRÜNÜN DEĞİL KURULUMUN (24 Ekim 2026, kullanıcı: «sistem içinde ALTEK ERP yazmasın»). Bu ekranlar oturumdan ÖNCE çiziliyor, yani
 * `core.brand.product_name`'i okuyamıyor; ad `VITE_BRAND_NAME`'den. «ERP» eki yok: ürünün kategorisi, kurulumun adı değil.
 * Yazı, görsel değil: ilk boyadan önce istek istemiyor ve her yoğunlukta net.
 *
 * `<main>` burada, çünkü bu ekranlar kabuğun dışında: belgenin tek `<main>`'i bu.
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="grid min-h-dvh grid-cols-1 grid-rows-[auto_minmax(0,1fr)] bg-surface lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] lg:grid-rows-1">
      <div className="login-visual flex min-h-36 items-end p-6 lg:min-h-0 lg:p-10">
        <div className="min-w-0">
          <div className="login-brand text-2xl font-semibold tracking-tight lg:text-3xl">{env.brandName}</div>
          <p className="login-note mt-1 text-sm">Kurum içi erişim</p>
        </div>
      </div>
      <main className="flex min-w-0 flex-col px-6 py-8 sm:px-12">
        <div className="my-auto w-full max-w-96 self-center">{children}</div>
        <p className="mt-8 text-center text-xs text-fg-muted">Bu sistemdeki her işlem kayıt altına alınır.</p>
      </main>
    </div>
  );
}

/**
 * Formun başlığı ve ne yapıldığını söyleyen tek cümle. Sayfanın tek `<h1>`'i: başlıkla gezinen ekran okuyucu ekranın ne olduğunu buradan bulur.
 */
export function AuthHeading({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="mb-2">
      <h1 className="text-xl font-semibold text-fg">{title}</h1>
      <p className="mt-1 text-base text-fg-muted">{children}</p>
    </div>
  );
}

/**
 * Uygulamanın YERİNE çizilen, oturum açıldıktan sonraki ekranların çerçevesi: ilk girişte parola, kapalı abonelik, müşteri seçimi.
 * Kurumun adı üstte, iş ortada bir kartta. Fotoğraf yok: kişi içeride ve sırada bir engel var, karşılama değil. Altta `BlockingScreen`'in
 * sabit «Çıkış yap»ı duruyor; `pb-20` kartın onun altında kalmasını önlüyor.
 */
export function AuthCardScreen({ children, width = "max-w-96" }: { children: ReactNode; width?: "max-w-96" | "max-w-md" }) {
  return (
    <div className="grid min-h-dvh place-items-center bg-bg-app p-6 pb-20">
      <div className={`flex w-full flex-col gap-6 ${width}`}>
        <div className="text-center">
          <div className="text-2xl font-semibold tracking-tight text-fg">{env.brandName}</div>
          <p className="mt-1 text-sm text-fg-muted">Kurum içi erişim</p>
        </div>
        <div className="rounded-lg border border-border bg-surface p-6 shadow-e1">{children}</div>
      </div>
    </div>
  );
}
